module.exports = __webpack_public_path__ + "img/individual2.ae8142a0.svg";